import { jsx as _jsx } from "react/jsx-runtime";
import { MaterialDropdown } from 'console/shared/components/fields';
export const tz_list = [
    { text: 'UTC+0 — Западноевропейское время', value: 0 },
    { text: 'UTC+1 — Центральноевропейское время', value: 1 },
    { text: 'UTC+2 — Калининградское время', value: 2 },
    { text: 'UTC+3 — Московское время', value: 3 },
    { text: 'UTC+4 — Самара, Удмуртия', value: 4 },
    { text: 'UTC+5 — Екатеринбург, Пермь, Курган, Тюмень', value: 5 },
    { text: 'UTC+6 — Омск', value: 6 },
    { text: 'UTC+7 — Новосибирск, Томск Красноярск, Кемерово', value: 7 },
    { text: 'UTC+8 — Иркутск, Бурятия', value: 8 },
    { text: 'UTC+9 — Якутия, Забайкальский край, Амурская область', value: 9 },
    { text: 'UTC+10 — Владивосток, Хабаровск', value: 10 },
    { text: 'UTC+11 — Магадан, Южно-Сахалинск', value: 11 },
    { text: 'UTC+12 — Камчатское время, Чукотка', value: 12 },
];
export const TimeZoneSelector = (input_props) => (_jsx(MaterialDropdown, { options: tz_list, ...input_props }));
